import { ResponseSchema } from '@/@types/schemas/responses'
import { GetFileS3KeyResponse } from '@/@types/schemas/responses/upload-file'
import { api } from '@/lib/api'

export async function GetFileS3Key(
  workspaceId: string,
  mimeType: string,
  entityType: 'company' | 'project' | 'bot' | 'user',
) {
  const resp = await api<GetFileS3KeyResponse>(
    `/company/${workspaceId}/upload`,
    {
      method: 'POST',
      data: {
        mimetype: mimeType,
        entity_type: entityType,
      },
    },
  )

  return resp
}

export async function UploadFileToS3ByURL(
  preSignedUrl: string,
  file: File,
): Promise<ResponseSchema<boolean>> {
  const resp = await fetch(preSignedUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
    },
  })

  return {
    statusCode: resp.status,
    message: '',
    data: resp.ok,
  }
}
